
import Vue from 'vue'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/remote-config'
export default Vue.extend({
  name: 'UserProfile',
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data: () => ({
    user: {
      displayName: ''
    },
    currentLang: localStorage.getItem('language') as string,
    languages: [] as Array<{ name: string, value: string }>,
    loading: false
  }),
  computed: {
    displayName (): string {
      return this.user.displayName
    }
  },
  created (): void {
    this.user.displayName = firebase.auth().currentUser.displayName
    const languages = firebase.remoteConfig().getValue('app_languages').asString()
    this.languages = JSON.parse(languages)
  },
  methods: {
    updateProfile (): void {
      this.loading = true
      firebase.auth().currentUser.updateProfile({
        displayName: this.user.displayName
      }).then(() => {
        this.$i18n.locale = this.currentLang.value
        localStorage.setItem('language', this.currentLang.value)
        this.$store.dispatch('user/patch', { language: this.currentLang.value, name: this.user.displayName })
        document.title = this.$t('app-title')
        this.loading = false
      }).catch((error) => {
        console.error(error)
        this.loading = false
      })
    }
  }
})
